import { useEffect, useRef, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Link2, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Relie en arrière-plan les contrats « Dépenses avec engagements » à tous les véhicules du parc.
export const LinkAllContractsButton = ({ onDone }) => {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const wasRunning = useRef(false);

  const poll = async () => {
    try {
      const { data } = await api.get("/fleet/auto-link-all");
      setJob(data.job);
      if (data.job?.status === "running") { wasRunning.current = true; timer.current = setTimeout(poll, 4000); }
      else if (wasRunning.current) {
        wasRunning.current = false;
        const j = data.job;
        toast.success(`${j.contracts_linked} contrat(s) relié(s) sur ${j.vehicles_linked} véhicule(s)`
          + (j.vehicles_with_suggestions ? ` · ${j.vehicles_with_suggestions} véhicule(s) avec suggestions à confirmer (onglet Contrat)` : "")
          + (j.errors ? ` · ${j.errors} erreur(s)` : ""));
        onDone?.();
      }
    } catch { /* silencieux */ }
  };
  useEffect(() => { poll(); return () => clearTimeout(timer.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const start = async () => {
    if (!window.confirm("Relier automatiquement les contrats de « Dépenses avec engagements » à tous les véhicules ? Seules les correspondances sûres (immatriculation ou VIN) sont reliées ; l'IA peut relire les PDF pas encore analysés (appel Gemini facturé sur ta clé).")) return;
    try {
      await api.post("/fleet/auto-link-all");
      toast.success("Liaison lancée en arrière-plan — tu peux continuer à travailler");
      poll();
    } catch (e) { toast.error(apiError(e)); }
  };

  const running = job?.status === "running";
  return (
    <Button variant="outline" onClick={start} disabled={running} data-testid="fleet-link-all-btn">
      {running ? <Loader2 className="w-4 h-4 mr-1.5 animate-spin" /> : <Link2 className="w-4 h-4 mr-1.5" />}
      {running ? `Liaison ${job.done}/${job.total}…` : "Relier les contrats de tout le parc"}
    </Button>
  );
};
